import mock from "../mocks/lda";
import data from "../mocks/data_lda.json";
type lda = {
  Título: Record<string, any>,
  Artigo: Record<string, any>,
  Capítulo: Record<string, any>
}

const artigos = Object.entries(data.Artigo);


export function useLDA() {
  return {
    ...mock
  };
}

export function getArtigos() {
  return data.Artigo;
}

export function getTitulos() {
  return data.Título;
}

export function mapSelectArtigos() {
  return artigos.map(([key, val]) => (key));

}

export function mapSelectParagrafo(artigo: string) {
  const p = find(getArtigos(), '', 'Parágrafo');
  return p.reduce((prev: any[], curr: any[]) => (prev.concat(curr)), []).filter((val: any) => (val.history.startsWith(`#${artigo}#`)));
}

export function mapSelectInciso(artigo: string) {
  const p = find(getArtigos(), '', 'Inciso');
  return p.reduce((prev: any[], curr: any[]) => (prev.concat(curr)), []).filter((val: any) => (val.history.startsWith(`#${artigo}#`)));
}

export function mapSelectAlinea(artigo: string) {
  //artigosN1.filter(([key, val]: any) => (key === pai && val.type === "Alínea")).map(([key, val]) => (key)),
  const p = find(getArtigos(), '', 'Alínea');
  const concat: any = (prev: any[], curr: any[]) => (prev.concat(curr[0]?.length? curr.reduce(concat, []) : curr));
  return p.reduce(concat, []).filter((val: any) => (val.history.startsWith(`#${artigo}#`)));
}

function find(obj: any, key: string = '', type: string = '', history: string = '') {
  if(!key && !type ) {
    return obj;
  }
  if(type && obj['type'] === type) {
    return {...obj, history};
  }
  if(key && type && obj[key] && obj[key]['type'] === type) {
    return {...obj[key], history: `${history}#${key}`};
  }
  if(key && !type && obj[key]) {
    return {...obj[key], history: `${history}#${key}`};
  }
  let resp = Object.entries(obj).map(([k, val]): any => typeof val === 'object'? find(val, key, type, `${history}#${k}`): null).filter((v) => (v));

  if(!resp || !resp?.length)
    return null;

  if(resp && !resp?.length)
    return [resp];

  return resp;
}